import React from 'react'
import QuestionFormElement from '../shared/Questions/QuestionFormElement'

interface Props {
	validator?: any
	answers: any
	parentQuestions: any[]
	setAnswers: ({ data, questionId }) => void
	classes?: any
}

function FormCompanyQuestions(props: Props) {
	//Component works based on parent question data passed to it
	const { parentQuestions = [], setAnswers, answers, classes = {} } = props
	return (
		<div>
			{Boolean(parentQuestions?.length) &&
				parentQuestions.map((question) => {
					return (
						<QuestionFormElement
							validator={props.validator}
							key={'FormCompanyQuestions-' + question.id}
							questionData={question}
							classes={classes}
							onChange={(data) => {
								setAnswers({ data, questionId: question.id })
							}}
							value={answers[question.id]?.answer}
						/>
					)
				})}
		</div>
	)
}

export default FormCompanyQuestions
